export default "__VITE_ASSET__luDYMYhI__"